import {Component} from '@angular/core';
import {WidgetInputDirective} from '../../directives/widget-input.directive';
import {ND} from '@pt/pt-models';

@Component({
  selector: 'pt-widget-recipient-chooser',
  template: `
    <div
      class="widget-border"
      data-testid="widget-recipient-chooser"
      id="widget_{{initializationWidget.internalId}}"
      [ngSwitch]='initializationWidget?.version'>

      <pt-widget-recipient-chooser-v0
        *ngSwitchCase='0'
        [lockAcquired]="lockAcquired"
        [initializationWidget]="initializationWidget"
        [status]="status">
      </pt-widget-recipient-chooser-v0>

      <pt-widget-version-missing
        *ngSwitchDefault
        [type]="initializationWidget?.type"
        [label]="initializationWidget?.label"
        [version]="initializationWidget?.version">
      </pt-widget-version-missing>

    </div>
  `
})
export class WidgetRecipientChooserComponent extends WidgetInputDirective {
  ND = ND;
}
